import {spacing} from "@khanacademy/wonder-blocks-tokens";

import {CARD_OFFSET, CONTROLS_HEIGHT} from "./constants.ts";

const MAX_DECK_DISPLAY_SIZE = 3;

const controlsCardWidth = (cardWidth: number) => cardWidth;
const controlsCardHeight = (cardHeight: number) =>
    cardHeight + CONTROLS_HEIGHT - CARD_OFFSET;

export function containerWidth(cardWidth: number): number {
    return controlsCardWidth(cardWidth) + CARD_OFFSET * MAX_DECK_DISPLAY_SIZE;
}

export function containerHeight(cardHeight: number): number {
    return controlsCardHeight(cardHeight) + CARD_OFFSET * MAX_DECK_DISPLAY_SIZE;
}

export function containerDimensions(cardWidth: number, cardHeight: number) {
    return {
        width: containerWidth(cardWidth) + spacing.xxxxSmall_2,
        height: containerHeight(cardHeight) + spacing.xxxxSmall_2,
    };
}

export function controlsCardDimensions(cardWidth: number, cardHeight: number) {
    return {
        width: controlsCardWidth(cardWidth),
        height: controlsCardHeight(cardHeight),
    };
}
